var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7996 3H1.66016V19.3645H24.7996V3Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6895 19.3647H10.7764V21.7746H15.6895V19.3647Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0345 23.9601H9.23828L10.7763 21.7744H15.6832L17.0345 23.9601Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2539 13.2647C14.5085 13.2647 15.5255 12.2477 15.5255 10.9932C15.5255 9.73868 14.5085 8.72168 13.2539 8.72168C11.9994 8.72168 10.9824 9.73868 10.9824 10.9932C10.9824 12.2477 11.9994 13.2647 13.2539 13.2647Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7974 10.9934C17.7974 10.5166 17.7246 10.0596 17.5855 9.62914L18.9365 8.84768L17.9498 7.13907L16.5988 7.92053C15.9829 7.24503 15.1617 6.76159 14.2411 6.55629V5H12.2676V6.56291C11.3405 6.76821 10.5259 7.25166 9.91001 7.92715L8.55902 7.1457L7.57227 8.85431L8.92326 9.63576C8.79081 10.0662 8.71134 10.5232 8.71134 11C8.71134 11.4768 8.78419 11.9338 8.92326 12.3642L7.57227 13.1457L8.55902 14.8543L9.91001 14.0728C10.5259 14.7483 11.3471 15.2318 12.2676 15.4371V17H14.2411V15.4371C15.1683 15.2318 15.9829 14.7483 16.5988 14.0728L17.9498 14.8543L18.9365 13.1457L17.5855 12.3642C17.718 11.9338 17.7974 11.4768 17.7974 11V10.9934Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemOptions);
export default __webpack_public_path__ + "static/media/systemOptions.21073a8a63b64d12e6e44af8c2d56e7d.svg";
export { ForwardRef as ReactComponent };